// @ts-ignore
import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import GoogleMe from "../components/GoogleMe";
import BookCall from "../components/BookCall";
import Footer from "../components/Footer";
import AuthorityBuilderFunnel from "../components/AuthorityBuilderFunnel";
import ClientWins from "../components/ClientWins";
import { Helmet } from "react-helmet";
import FlodeskEmbed from "../components/FlodeskEmbed";
import FeaturedProjects from "../components/FeaturedProjects";
import Brandlist from "../components/Brandlist";

function Home() {
<Helmet>
  <title>
    Web Design & Custom App Development for Women Entrepreneurs | Woaom Web Design
  </title>
  <meta
    name="description"
    content="Woaom Web Design builds high-converting websites and custom apps for women entrepreneurs and women-led businesses. From SEO and branding to scalable digital platforms, we help female founders in Dallas, Austin, Houston, New York City, and beyond grow their online presence."
  />
  <meta
    name="keywords"
    content="Custom web design for women entrepreneurs, app development for women-owned businesses, branding for female founders, bespoke web design for women in business, women-led business website design, consulting website design for women entrepreneurs, professional services web development for women-owned firms, ecommerce solutions for women-led brands, digital strategy for women-owned businesses, React developer for women-owned startups, Tailwind CSS developer for women-led brands, Firebase app development for women entrepreneurs, Austin custom web design for women-owned businesses, Dallas web design for female founders, Fort Worth women-led business website design, Houston web design for women entrepreneurs, San Antonio women-owned brand website design, Lubbock women entrepreneurs custom websites, Atlanta GA women-owned business web design, New York City web design for female founders, Washington DC custom websites for women-led firms, Philadelphia PA web design for women entrepreneurs, Memphis TN women-owned business website development, Baton Rouge LA websites for women entrepreneurs, Shreveport LA custom web design for women-led businesses, New Orleans web design for female founders, Macon GA websites for women entrepreneurs, Augusta GA women-owned web design services, Baltimore women-led business website solutions, scalable web solutions for women-owned startups, SEO web design for women entrepreneurs, digital branding for female founders, consultant website design for women-owned firms, professional services client portal for women in business, custom coaching platform design for women, online course platform for female entrepreneurs, women-owned business CRM integration, digital transformation for women entrepreneurs, ecommerce platform development for women-owned brands, high-end professional website for women executives, member portal development for female-led organizations, custom ecommerce store for women entrepreneurs, direct-to-consumer ecommerce for women-owned brands, fashion ecommerce for women-led businesses, growth strategy websites for female founders, automated business processes for women entrepreneurs, personal branding websites for women leaders, strategic digital presence for women-owned businesses, tech solutions for female founders, custom software for women entrepreneurs, high-converting websites for women executives, elevate your online brand as a woman entrepreneur, web design and app development for women-led businesses"
  />
</Helmet>


  return (
    <div>
      <Hero />
      <About />
      <Services />
      <FeaturedProjects/>
      <Brandlist/>
      <GoogleMe />
      <ClientWins />
      <BookCall />
      <AuthorityBuilderFunnel />
 {/* <AuthorityBuilderFunnel/> */}
       <div>
                </div>
      <Footer />

      
    </div>
  );
}

export default Home;
